// extracted by mini-css-extract-plugin
export var chip = "_eu-0";
export var filterDropdown = "_eu-5";
export var filterItem = "_eu-6";
export var icon = "_eu-1";
export var removeButton = "_eu-3";
export var removeIcon = "_eu-4";
export var separator = "_eu-2";